import page from './page.json'

const ko = {
  page
}

export default ko;